import React from 'react';
import BrandLogos from '../Home/HomepageV2/BrandLogos';
import PlatformHero from 'src/components/Platform/PlatformHero';
import PlatformPageSection from 'src/components/Platform/PlatformPageSection';
import TextWithHighlight from '../Home/HomepageV2/TextWithHighlight';
import classNames from 'classnames';
import { IPlatformPage, IPlatformPageSection, PlatformPageSectionType } from '@/shared/types/platform-pages';
import { PLATFORM_PAGE_CLASS } from '@/shared/constants/platform-pages-constants';
import StartNow from '../Home/HomepageV2/StartNow';
import './index.less';

interface IProps {
  content: IPlatformPage;
  utmSource: string;
  redirectUrl?: string;
}

export default function PlatformPage({ content, utmSource, redirectUrl }: IProps) {
  return (
    <div className={classNames('platform-page', { [PLATFORM_PAGE_CLASS[content.type]]: true })}>
      <div className="hover-content">
        {content.hero && (
          <PlatformHero
            redirectUrl={redirectUrl}
            title={content.title}
            content={content.hero}
            type={content.type}
            utmSource={utmSource}
          />
        )}
        {content.brandLogos && <BrandLogos />}
        {content.textWithHighlight && <TextWithHighlight />}
        {content.sections.map((section: IPlatformPageSection, i: number) =>
          section.type === PlatformPageSectionType.EMPTY ? (
            <div key={i}></div>
          ) : (
            <PlatformPageSection key={i} content={section} utmSource={utmSource} redirectUrl={redirectUrl} />
          ),
        )}
      </div>
      {content.hero?.showSignUp && <StartNow />}
    </div>
  );
}
